'use client'

import type { VeritonicScriptProps } from './types'

/**
 * Component that injects the Veritonic script into the page
 *
 * This component handles the script injection using the same approach as layout.tsx.
 * It uses a regular script tag with dangerouslySetInnerHTML.
 *
 * @example
 * ```tsx
 * <VeritonicScript veritonicId="8nb4pl7r" gdpr="consent_string" />
 * ```
 */
export const VeritonicScript: React.FC<VeritonicScriptProps> = ({ veritonicId, gdpr }) => {
  if (!veritonicId) {
    return null
  }

  const scriptContent = `
    (function(w, d){
      var id="vpr-capture", n = "script"
      if (!d.getElementById(id)) {
        vpr = w.vpr || function() {(w.vpr.a = w.vpr.a || []).push(arguments);};
        var e = d.createElement(n); e.id = id; e.async=1
        e.src = "https://cdn.veritonic.com/static/vpr.min.js"
        var s = d.getElementsByTagName(n)[0]
        s.parentNode.insertBefore(e, s)
      }
      vpr("veritonic_id", "${veritonicId}");${gdpr ? `\n      vpr("gdpr", "${gdpr}");` : ''}
    })(window, document);
  `

  return (
    <script
      id="veritonic-script"
      dangerouslySetInnerHTML={{
        __html: scriptContent,
      }}
    />
  )
}
